webpackJsonp([58],{

/***/ "PNDN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-success-stories-list_99af01f61376d5d84a2cd4367ad27477.html";

/***/ }),

/***/ "VQP1":
/***/ (function(module, exports, __webpack_require__) {

var SectionSuccessStoriesList = (function () {
    function SectionSuccessStoriesList() {
    }
    return SectionSuccessStoriesList;
}());
angular.module('animatronApp.sectionSuccessStoriesList', []).component('sectionSuccessStoriesList', {
    controller: SectionSuccessStoriesList,
    templateUrl: __webpack_require__("PNDN")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/58-28dc41a6a889e793a2e2.min.js